"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryHash = getQueryHash;
function getQueryHash(locationHash) {
  if (locationHash?.startsWith('#opi')) {
    const itemID = locationHash.replace('#opi', '');
    if (itemID.length > 0) {
      return itemID;
    }
  }
  return undefined;
}
